import { AllocationItemModel } from "@/model/allocation/allocationModel";

export function ConvertToAllocationItemModel(allocationList: Array<Record<string, any>>) {
  const allocationItemList: AllocationItemModel[] = [];
  if (allocationList && allocationList.length) {
    for (const allocationItem of allocationList) {
      const item = new AllocationItemModel();
      item.allocationDocumentFinanceType = allocationItem.allocationDocumentFinanceType;
      item.description = allocationItem.description;
      item.id = allocationItem.id;
      item.isArchived = allocationItem.isArchived;
      item.isDeleted = allocationItem.isDeleted;
      item.number = allocationItem.number;
      item.name = allocationItem.name;
      allocationItemList.push(item);
    }
  }
  return allocationItemList;
}
